'use strict';

angular.module('client.services').factory('elementConfigService', ['$log', '$resource', 'api_server',
  function ($log, $resource, api_server) {

    let elementConfigResource = $resource(api_server + '/experiences/:id/elements/:eid/config', {config: '@config'},
      {
        getConfig: {method: 'GET', params: {id: '@experienceId', eid: '@elementId'}},
        saveConfig: {method: 'POST', params: {id: '@experienceId', eid: '@elementId'}}
      });

    let experienceConfigResource = $resource(api_server + '/experiences/:id/elements/config', {},
      {
        getConfig: {method: 'GET', isArray: true, params: {id: '@experienceId'}}
      });

    function getElementConfig(experienceId, elementId) {
      return elementConfigResource.getConfig({id: experienceId, eid: elementId}).$promise;
    }

    function getExperienceConfig(experienceId) {
      return experienceConfigResource.getConfig({id: experienceId}).$promise;
    }

    function updateElementConfig(experienceId, elementId, config) {
      return elementConfigResource.saveConfig({id: experienceId, eid: elementId}, {config: config}).$promise;
    }

    return {
      getElementConfig: getElementConfig,
      getExperienceConfig: getExperienceConfig,
      updateElementConfig: updateElementConfig
    };
  }]);